module.exports = __webpack_public_path__ + "img/ico_delete.7264f308.svg";